<template>
  <div id=navbar>
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand href="/">
      <img class='logo' v-bind:src="require('../assets/NLP_E8_Logo_bel.png')" alt="model icon">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <!--<b-nav-item v-if="$store.getters.language === 'SLO'" @click="goto('model-list-container')">O nas</b-nav-item>-->
          <!--<b-nav-item v-else @click="goto('model-list-container')">About</b-nav-item>-->
          <b-nav-item v-if="$store.getters.language === 'SLO'" @click="goto('about-section')">Modeli</b-nav-item>
          <b-nav-item v-else @click="goto('about-section')">Models</b-nav-item>
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <em>{{ $store.getters.language }}</em>
            </template>
            <b-dropdown-item @click="changeLang('ENG')">ENG</b-dropdown-item>
            <b-dropdown-item @click="changeLang('SLO')">SLO</b-dropdown-item>
          </b-nav-item-dropdown>
          
          <b-nav-item-dropdown v-if="isLoggedIn" right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <em>{{ user }}</em>
            </template>
            <b-dropdown-item v-if="$store.getters.language === 'SLO'" @click="logout">Odjavi se</b-dropdown-item>
            <b-dropdown-item v-else @click="logout">Sign out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import store from '../store.js'

export default {
  name: "NavbarComponent",
  methods: {
    logout: function () {
      let data = {
        email: this.user,
      }
      this.$store.dispatch('logout', data)
     .then(() => 
        this.$router.push('/'),
      )
     .catch(err => console.log(err))
    },
    goto(id) {
      if (this.$route.path === '/') {
        document.getElementById(id).scrollIntoView({
          behavior: "smooth"
        });
      }
      else {
        this.$router.push('/')
      }
    },
    changeLang(lang) {
      this.$store.dispatch('save_language', lang)
    }
  },
  computed: {
    isLoggedIn: {
      get () {
        return store.getters.isLoggedIn
      },
    },
    user: {
      get () {
        return store.getters.getUser
      },
    }
  }
}


</script>

<style lang="scss">
  $tablet-width: 768px;
  $desktop-width: 1024px;
  .navbar.navbar-dark{
    background-color: #449971!important;
    padding-left: 30px;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  #navbar .logo {
    max-height: 42px;
  }

  .nav-item a {
    color: #ffffff !important;
  }

  .dropdown-menu a {
    color: #4F6675 !important;
  }

  @media (min-width: #{$desktop-width}) {
    .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 2rem !important;
        padding-left: 2rem !important;
    }
  }

</style>